/* eslint-disable eqeqeq */
import BackendLayout from "../../layouts/BackendLayout";
import React, {useEffect, useState, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import getPageBreadcrumb from "../../services/BreadcrumbServices";
import {REGISTER_INSPECTION} from "../../constants/routes";
import {getRegisterInspectionPageSettings} from "../../api/setting/pageApi";
import {setPageSettings} from "../../store/actions/pageActions";
import StepBar from "../../components/StepBar";
import {useDocumentTitle, useTableInspectionItemsScroll} from "../../hooks";
import CalendarIcon from "../../assets/icons/calendar-big-icon.svg";
import PageEditIcon from "../../assets/icons/page-edit-icon.svg";
import SettingIcon from "../../assets/icons/setting-big-icon.svg";
import VerifiedUserIcon from "../../assets/icons/verified-user-icon.svg";
import ToolIcon from "../../assets/icons/inspection-number-icon.svg";
import CustomImg from "../../components/CustomImg";
import {PageTitle} from "../../components/admin";
import CustomSpan from "../../components/CustomSpan";
import Select2 from "../../components/Select2";
import {
  TextInput,
  Label,
  CheckboxInput,
  FormGroupInput,
  DatetimePicker,
  RemarkDetail,
  ButtonBack,
  Button,
  ButtonDPad,
  JudgmentLimit,
  RedirectAlert,
} from "../../components";
import {hasErrorInput, getFileIdsFromEditor} from "../../utils";
import {getSelectedValue, formatUserOptions, convertToOptions} from "../../utils/select-utils";
import Table from "../../components/table/Table";
import {useParams, useNavigate} from "react-router-dom";
import {
  getInformationInspection,
  register,
  registerTemporary,
  changeMachineInput,
  changeMachineSelect
} from "../../services/inspection/RegisterInspection"
import {errorStatusHandle} from "../../utils/error-utils";
import {
  formatDate,
  formatDateTime
} from "../../utils/datetime-utils";
import store from "../../store";
import {HTTP_ERROR_CODES} from "../../constants/error";
import {
  setRegisterInspectionAlertError,
  resetAlert,
  setButtonProcessing,
  clearButtonProcessing,
  setAlertSuccess, setAlertError,
} from "../../store/actions";
import PageAlert from '../../components/alerts/PageAlert';
import {MACHINE_INPUT} from "../../constants/routes";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import {LiaEditSolid} from "react-icons/lia";
import { FiEdit2 } from "react-icons/fi";
import {smoothScrollToTop} from "../../utils/common-utils";
import {
  clearPageLoading,
  setPageLoading
} from '../../store/actions';
import {
  BUTTON_REGISTER_INSPECTION,
  BUTTON_REGISTER_TEMPORARY_INSPECTION,
  BUTTON_SET_TEMPORARY_INSPECTION
} from "../../constants/buttons";
import {
  INSPECTION_ITEM_JUDGMENT_INPUT_TYPE,
} from "../../constants/app";
import {
  getBackgroundSymbol,
  getInspectionUnit,
  formatUserDisplay
} from "../../utils/display-utils";
import TextEditor from "../../components/form/inputs/TextEditor";
import InputLabel from "../../components/InputLabel";
import {Modal} from "flowbite-react";
import TooltipComment from "../../components/TooltipComment"
import {REGISTER_INSPECTION_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";


export default function RegisterInspectionPage() {
  useRedirectPage(REGISTER_INSPECTION_PAGE);
  const stepBarItems = [
    {spanText: '設備入力', hasPassed: true},
    {spanText: '点検結果登録', isActive: true, isBack: true}
  ];
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const {templateId, machineId} = useParams();
  const auth = store.getState().auth;
  const dispatch = useDispatch();
  const [inspectionMachine, setInspectionMachine] = useState([]);
  const [template, setTemplate] = useState({});
  const [tempInspection, setTempInspection] = useState({});
  const [remarkText, setRemarkText] = useState(null);
  const [now, setNow] = useState(new Date());
  const [commentFiles, setCommentFiles] = useState([]);
  const [commentImagesThumb, setCommentImagesThumb] = useState([]);
  const [managerUsers, setManagerUsers] = useState([]);
  const [inspectionItem, setInspectionItem] = useState([]);
  const maxHeightTable = useTableInspectionItemsScroll(tableRef, inspectionItem);
  const [errorMessagesRegister, setErrorMessagesRegister] = useState({});
  const [canInspect, setCanInspect] = useState(false);
  const [formRegister, setFormRegister] = useState({
    execution_date: formatDate(new Date()),
    execution_user_id: auth.user.id,
    has_inspected: true
  });
  const [showResume, setShowResume] = useState(false);
  const resultField = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_field
  );
  const inspectionSettings = useSelector((s) => s.app_settings.inspection);


  useEffect(() => {
    setRegisterInspectionPageSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateId, machineId]);

  const handleInputChange = (key, value) => {
    setFormRegister(prev => ({
      ...prev,
      [key]: value
    }))
  };

  const handleCheckBoxChange = (key, value) => {
    setFormRegister(prev => {
      const newFormRegister = {...prev};
      if (newFormRegister[key] === value) {
        newFormRegister[key] = '';
      } else {
        newFormRegister[key] = value;
      }
      return newFormRegister;
    });
  };

  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );

  const breadcrumb = getPageBreadcrumb(REGISTER_INSPECTION);
  const setRegisterInspectionPageSettings = async () => {
    dispatch(setPageLoading());
    try {
      const pageSettings = await getRegisterInspectionPageSettings();
      const datetimeNow = pageSettings.datetime;
      setNow(datetimeNow);
      dispatch(setPageSettings(pageSettings));

      const inspectionInfo = await getInformationInspection(templateId, machineId);
      const listInspection = inspectionInfo.data.template.inspection_template;
      formRegister['machine'] = inspectionInfo.data.machine.name;
      formRegister['machine_id'] = inspectionInfo.data.machine.id;

      setInspectionMachine(convertToOptions(inspectionInfo.data.inspection_machines));
      if (inspectionSettings?.machine_change_method_text === true) {
        setInspectionMachine(inspectionInfo.data.machine.name);
      }

      setInspectionItem(listInspection);
      setTemplate(inspectionInfo.data.template);
      setManagerUsers(formatUserOptions(inspectionInfo.data.manager_users));
      setCanInspect(inspectionInfo.data.can_inspect);
      if (!inspectionInfo.data.can_inspect) {
        dispatch(setAlertError('承認設定に属していない点検テンプレートが選択されました。システム管理者に連絡し、承認設定画面で点検テンプレートの設定を行ってください。'))
      }

      const updatedFormRegister = Object.keys(resultField).reduce((acc, key) => {
        if (key.toLowerCase() === 'registration_datetime') {
          return acc;
        }

        if (key.toLowerCase().includes("datetime")) {
          acc[key] = datetimeNow;
        } else if (key.toLowerCase().includes("user_id")) {
          acc[key] = auth.user.id;
        } else {
          acc[key] = '';
        }
        return acc
      }, {...formRegister});

      const updatedForm = listInspection.reduce((acc, item, index) => {
        acc[`type_inspection_item_${item.id}`] = item.inspection_item_type.name;
        acc[`inspection_item_${item.id}`] = '';
        return acc;
      }, {...updatedFormRegister});
      if (inspectionInfo.data.temporary_info) {
        setShowResume(true);
        setTempInspection(inspectionInfo.data.temporary_info);
      }
      updatedForm['inspection_number'] = inspectionInfo.data.inspection_number;
      setFormRegister(updatedForm);
    } catch (e) {
      errorStatusHandle(e);
    } finally {
      dispatch(clearPageLoading());
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(setButtonProcessing(BUTTON_REGISTER_INSPECTION));
    try {
      const formData = generateFormData();
      const response = await register(templateId, machineId, formData);
      if (response.success) {
        localStorage.setItem('successMessageInspection', response.message);
        navigate(response.nextUrl);
      }
      setErrorMessagesRegister([]);
      smoothScrollToTop();
    } catch (e) {
      errorStatusHandle(e);
      if (e.status === HTTP_ERROR_CODES.BAD_REQUEST) {
        let responseData = e.data;
        dispatch(setRegisterInspectionAlertError(responseData));
        setErrorMessagesRegister(responseData.errors)
      }
      smoothScrollToTop();
    } finally {
      dispatch(clearButtonProcessing(BUTTON_REGISTER_INSPECTION));
    }
  };

  const handleSetTemporary = () => {
    dispatch(setButtonProcessing(BUTTON_SET_TEMPORARY_INSPECTION));
    const newFormRegister = {...formRegister};
    if (tempInspection?.inspection_result) {
      tempInspection.inspection_result.forEach((item => {
        const key = `inspection_item_${item.inspection_item_id}`;
        if (key in newFormRegister) {
          newFormRegister[key] = item.inspection_item_value;
        }
      }))
    }
    Object.keys(resultField).forEach((key) => {
      if (key.toLowerCase() === 'registration_datetime') {
        return;
      }
      if (key.toLowerCase().includes("datetime")) {
        newFormRegister[key] = tempInspection[key] ? formatDateTime(new Date(tempInspection[key])) : tempInspection[key];
      } else {
        newFormRegister[key] = tempInspection[key];
      }
    });
    if (tempInspection?.remark_text) {
      setRemarkText(tempInspection.remark_text);
      newFormRegister['remark_text'] = tempInspection.remark_text;
    }
    newFormRegister['has_inspected'] = tempInspection.has_inspected === 'true';
    setFormRegister(newFormRegister);

    setTimeout(() => {
      dispatch(clearButtonProcessing(BUTTON_SET_TEMPORARY_INSPECTION));
      setShowResume(false);
    }, 0);
  };

  const generateFormData = () => {
    const formData = new FormData();
    Object.keys(formRegister).forEach(key => {
      if (formRegister[key] !== null) {
        formData.append(key, formRegister[key])
      } else {
        formData.append(key, '')
      }
    });

    if (formRegister?.remark_text) {
      const fileIdsInEditor = getFileIdsFromEditor(formRegister.remark_text);
      const filteredFiles = commentFiles.filter(file => fileIdsInEditor.includes(file.id));
      const filteredImagesThumb =  commentImagesThumb.filter(file => fileIdsInEditor.includes(file.id));

      filteredFiles.forEach((file) => {
        formData.append('comment_file_ids', file.id);
        formData.append('comment_files', file.file);
      });

      filteredImagesThumb.forEach((file) => {
        formData.append('comment_images_thumb', file.file);
        formData.append('comment_image_thumb_ids', file.id);
      });

      fileIdsInEditor.forEach((id) => {
        formData.append('all_comment_file_ids', id);
      });
    }

    return formData
  };

  const handleMachineChangeInput = async (e) => {
    if (e.key === 'Enter') {
      try {
        const formData = new FormData();
        formData.append('machine', formRegister['machine']);
        const response = await changeMachineInput(templateId, formData);
        dispatch(resetAlert());
        navigate(response.nextUrl);
        setErrorMessagesRegister([]);
      } catch (e) {
        errorStatusHandle(e);
        if (e.status === HTTP_ERROR_CODES.BAD_REQUEST) {
          let responseData = e.data;
          dispatch(setRegisterInspectionAlertError(responseData));
          setErrorMessagesRegister(responseData.errors)
        }
      }
    }
  };

  const handleMachineChangeSelect = async (machineId) => {
    try {
      const response = await changeMachineSelect(templateId, {'machine_id': machineId});
      dispatch(resetAlert());
      navigate(response.nextUrl);
      setErrorMessagesRegister([]);
    } catch (e) {
      errorStatusHandle(e);
      if (e.status === HTTP_ERROR_CODES.BAD_REQUEST) {
        let responseData = e.data;
        dispatch(setRegisterInspectionAlertError(responseData));
        setErrorMessagesRegister(responseData.errors)
      }
    }
  };

  const handleSubmitTemporary = async (e) => {
    e.preventDefault();
    dispatch(setButtonProcessing(BUTTON_REGISTER_TEMPORARY_INSPECTION));
    try {
      const formData = generateFormData();

      const response = await registerTemporary(templateId, machineId, formData);
      if (response.success) {
        dispatch(setAlertSuccess(response.message));
        setErrorMessagesRegister([]);
        setCommentFiles([]);
        smoothScrollToTop();
      }
    } catch (e) {
      errorStatusHandle(e);
      if (e.status === HTTP_ERROR_CODES.BAD_REQUEST) {
        let responseData = e.data;
        dispatch(setRegisterInspectionAlertError(responseData));
        setErrorMessagesRegister(responseData.errors)
      }
      smoothScrollToTop();
    } finally {
      dispatch(clearButtonProcessing(BUTTON_REGISTER_TEMPORARY_INSPECTION));
    }
  };

  const firstInputIndex = inspectionItem.findIndex(item => item.inspection_item_type.name === 'input');

  const handleSelectChange = (selectOption, name) => {
    var value = '';
    if (selectOption) {
      value = selectOption.value
    }

    setFormRegister({
      ...formRegister,
      [name]: value
    })
  };

  const handleCheckInspected = () => {
    setFormRegister(prev => {
      const newFormRegister = {...prev};
      inspectionItem.forEach(item => {
        const key = `inspection_item_${item.id}`;
        if (key in newFormRegister) {
          newFormRegister[key] = '';
        }
      });
      if (prev.has_inspected) {
        newFormRegister['operation_start_datetime'] = null;
        newFormRegister['operation_start_user_id'] = '';
      }
      newFormRegister.has_inspected = !prev.has_inspected;
      return newFormRegister
    });
    setErrorMessagesRegister([]);
    dispatch(resetAlert());
  };

  const handleButtonBack = () => {
    dispatch(resetAlert());
    return navigate(MACHINE_INPUT);
  };

  useDocumentTitle("点検結果登録 - 点検王");
  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <StepBar stepBarItems={stepBarItems}/>
      <PageTitle title="点検結果登録"/>
      <ButtonDPad/>
      <div className="inline-block mt-4 mr-[24px]">
        <div className="w-full flex flex-col justify-start xl:gap-[16px] gap-[18px]">
          <RedirectAlert className="!mb-0"/>
          <PageAlert className="!mb-0"/>
          <div
            className="flex items-center 2xl:gap-[60px] xl:gap-[16px] tenken__text-gray-900 lg:gap-[12px] gap-[8px]"
            id="scroll_top">
            <div
              className="flex items-center 2xl:px-[16px] 2xl:py-[10px] px-[12px] py-[8px] border w-fit border-[#E0E0E0] bg-white rounded-lg 2xl:gap-[20px] xl:gap-[12px] gap-[10px] 2xl:h-[92px] lg:h-[88px] h-[81px]">
              <div className="flex flex-col">
                <Label text="実施日" className="w-[140px] tenken__text-gray-900" htmlFor="execution_date"/>
                <Label name="execution_date"
                       className="tenken__text-gray-900 xl:py-[6px] py-[4px] xl:text-[16px] text-[15px] 2xl:w-[180px] w-[155px]"
                       id="execution_date"
                       text={formatDate(now)}/>
              </div>
              <CustomImg src={CalendarIcon} alt="Calendar Icon"
                         className="2xl:max-w-[48px] 2xl:h-[48px] xl:max-w-[40px] xl:h-[40px] max-w-[36px] h-[36px]"></CustomImg>
            </div>
            <div
              className="flex items-center 2xl:px-[16px] 2xl:py-[10px] px-[12px] py-[8px] border w-fit border-[#E0E0E0] bg-white rounded-lg 2xl:gap-[20px] xl:gap-[12px] gap-[10px] 2xl:h-[92px] lg:h-[88px] h-[81px]">
              <div className="flex flex-col">
                <Label text="設備No." className="w-[140px] tenken__text-gray-900" htmlFor="machine_no"/>
                {inspectionSettings?.machine_change_method_select === true && (
                  <Select2 name="machine_no"
                           options={inspectionMachine}
                           classNamePrefix="react-select"
                           className="tenken__text-gray-900 xl:text-[16px] text-[15px] 2xl:w-[180px] w-[155px]"
                           id="machine_no"
                           placeholder=""
                           maxLength={200}
                           widthMenu="180px"
                           onChange={(inspectionMachine) => handleMachineChangeSelect(inspectionMachine.value)}
                           value={getSelectedValue(inspectionMachine, formRegister['machine_id'])}
                           hasError={hasErrorInput(errorMessagesRegister, 'machine_id')}
                  />
                )}
                {inspectionSettings?.machine_change_method_text === true && (
                  <TextInput
                    className="tenken__text-gray-900 xl:text-[16px] text-[15px] 2xl:w-[180px] w-[155px]"
                    name="machine" autoFocus
                    id="machine"
                    maxLength={200}
                    nextFocus={false}
                    readOnly={!canInspect}
                    disabled={!canInspect}
                    value={formRegister['machine']}
                    onKeyPress={handleMachineChangeInput}
                    onChange={(e) => handleInputChange(`machine`, e.target.value)}
                    hasError={hasErrorInput(errorMessagesRegister, 'machine')}
                  />
                )}
              </div>
              <CustomImg src={SettingIcon} alt="Setting Icon"
                         className="2xl:max-w-[48px] 2xl:h-[48px] xl:max-w-[40px] xl:h-[40px] max-w-[36px] h-[36px]"></CustomImg>
            </div>
            <div
              className="flex items-center 2xl:px-[16px] 2xl:py-[10px] px-[12px] py-[8px] border border-[#E0E0E0] bg-white rounded-lg 2xl:gap-[20px] xl:gap-[12px] gap-[10px] 2xl:h-[92px] lg:h-[88px] h-[81px]">
              <div className="flex flex-col">
                <Label text="点検テンプレート名" className="tenken__text-gray-900" htmlFor="template"/>
                <Label name="template"
                       className="xl:py-[6px] py-[4px] tenken__text-gray-900 xl:text-[16px] text-[15px] truncate 2xl:w-[220px] xl:w-[200px] w-[175px]"
                       id="template"
                       title={template && Object.keys(template).length > 0 ? template.name : ''}
                       text={template && Object.keys(template).length > 0 ? template.name : ''}/>
              </div>
              <CustomImg src={PageEditIcon} alt="User icon"
                         className="2xl:max-w-[48px] 2xl:h-[48px] xl:max-w-[40px] xl:h-[40px] max-w-[36px] h-[36px]"></CustomImg>
            </div>
            <div
              className="flex items-center 2xl:px-[16px] 2xl:py-[10px] px-[12px] py-[8px] w-fit border border-[#E0E0E0] bg-white rounded-lg 2xl:gap-[20px] xl:gap-[12px] gap-[10px] 2xl:h-[92px] lg:h-[88px] h-[81px]">
              <div className="flex flex-col">
                <Label text="ユーザー" className="w-[140px] tenken__text-gray-900" htmlFor="user"/>
                <Label name="user"
                       className="tenken__text-gray-900 xl:text-[16px] text-[15px] py-[4px] truncate  2xl:w-[220px] xl:w-[200px] w-[175px]"
                       id="user"
                       title={formatUserDisplay(auth.user)}
                       text={formatUserDisplay(auth.user)}/>
              </div>
              <CustomImg src={VerifiedUserIcon} alt="User icon"
                         className="2xl:max-w-[48px] 2xl:h-[48px] xl:max-w-[40px] xl:h-[40px] max-w-[36px] h-[36px]"></CustomImg>
            </div>
            <div
              className="flex items-center 2xl:px-[16px] 2xl:py-[10px] px-[12px] py-[8px] w-fit border border-[#E0E0E0] bg-white rounded-lg 2xl:gap-[20px] xl:gap-[12px] gap-[10px] 2xl:h-[92px] lg:h-[88px] h-[81px]">
              <div className="flex flex-col">
                <Label text="点検回数" className="min-w-[100px] tenken__text-gray-900" htmlFor="inspection_number"/>
                <Label name="inspection_number"
                       className="tenken__text-gray-900 xl:text-[16px] text-[15px] py-[4px]"
                       id="inspection_number"
                       text={`${formRegister['inspection_number']}回目`}/>

              </div>
              <CustomImg src={ToolIcon} alt="Tool icon"
                         className="2xl:max-w-[48px] 2xl:h-[48px] xl:max-w-[40px] xl:h-[40px] max-w-[36px] h-[36px]"></CustomImg>
            </div>
          </div>
          <div className="flex flex-col flex-start w-full max-w-[1674px] min-w-[1120px] xl:gap-[24px] gap-[18px]">
            <div className="flex flex-col gap-[8px]">
              <div className="flex justify-between items-center self-stretch">
                <CustomSpan text="点検結果を入力してください" className="lg:text-[16px] text-[15px] tenken__text-gray-900"/>
                <div className="flex justify-end items-center">
                  <CheckboxInput name="has_inspected" id="has_inspected" disabled={!canInspect}
                                 checked={!formRegister['has_inspected']}
                                 onChange={handleCheckInspected}
                                 label="設備が停止中のため点検しない"
                                 classLabel="lg:text-[16px] text-[15px] tenken__text-gray-900">
                  </CheckboxInput>
                </div>
              </div>
              <div className="relative rounded-lg border border-[#e0e0e0] overflow-y-auto" style={{
                maxHeight: maxHeightTable ? `${maxHeightTable}px` : "auto"
              }} ref={tableRef}>
                <Table className="no-drop-shadow-table" striped>
                  <Table.Head className={`${maxHeightTable ? 'sticky top-0 z-[8]' : ''}`}>
                    <Table.HeadCell
                      className="!normal-case w-[76px]"
                    >
                      <span>No.</span>
                    </Table.HeadCell>
                    <Table.HeadCell>
                      <span className="whitespace-nowrap">点検項目</span>
                    </Table.HeadCell>
                    <Table.HeadCell>
                      <span className="whitespace-nowrap">判定基準</span>
                    </Table.HeadCell>
                    <Table.HeadCell>
                      <span className="inline-block min-w-[40px] whitespace-nowrap">下限</span>
                    </Table.HeadCell>
                    <Table.HeadCell>
                      <span className="inline-block min-w-[40px] whitespace-nowrap">上限</span>
                    </Table.HeadCell>
                    <Table.HeadCell>
                    </Table.HeadCell>
                    <Table.HeadCell>
                      <span className="whitespace-nowrap">留意事項</span>
                    </Table.HeadCell>
                    <Table.HeadCell className="2xl:w-[320px] xl:w-[240px] w-[200px]">
                      <span className="whitespace-nowrap">点検結果</span>
                    </Table.HeadCell>
                  </Table.Head>
                  <Table.Body className="devide-y text-base">
                    {inspectionItem && inspectionItem.length > 0 ? (
                      inspectionItem.map((item, index) => (
                        <Table.Row key={index}>
                          <Table.Cell>
                            <span>{index + 1}</span>
                          </Table.Cell>
                          <Table.Cell className="max-w-[400px]">
                            <span
                              className="break-all"
                              style={{color: item.title_color}}
                            >
                              {item.title}
                            </span>
                          </Table.Cell>
                          <Table.Cell className="max-w-[300px]">
                            <span
                              className="break-all"
                              style={{color: item.description_color}}
                            >
                              {item.description}
                            </span>
                          </Table.Cell>
                          <Table.Cell className="max-w-[300px]">
                            <JudgmentLimit
                              value={item.inspection_judgment?.lower_value}
                              boundaryType={item.inspection_judgment?.lower_boundary_type}
                              unit={item.unit}
                              type="lower"
                            />
                          </Table.Cell>
                          <Table.Cell className="max-w-[300px]">
                            <JudgmentLimit
                              value={item.inspection_judgment?.upper_value}
                              boundaryType={item.inspection_judgment?.upper_boundary_type}
                              unit={item.unit}
                              type="upper"
                            />
                          </Table.Cell>
                          <Table.Cell>
                            <span
                              title={item.unit}
                              className="whitespace-nowrap"
                            >
                              {item.unit ? getInspectionUnit(item.unit, true) : "-"}
                            </span>
                          </Table.Cell>
                          <Table.Cell>
                            <RemarkDetail key={index} rowData={item}/>
                          </Table.Cell>
                          <Table.Cell>
                            {item.inspection_item_type?.name === 'checkbox' && (
                              <div className="flex items-center 2xl:gap-[32px] xl:gap-[28px] gap-[24px]">
                                <CheckboxInput name={`inspection_item_${item.id}`}
                                               id={`inspection_item_OK_${item.id}`}
                                               value="OK"
                                               disabled={!formRegister['has_inspected'] || !canInspect}
                                               onChange={() => handleCheckBoxChange(`inspection_item_${item.id}`, 'OK')}
                                               checked={formRegister[`inspection_item_${item.id}`] === 'OK'}
                                               label={resultSymbolSetting['passed'].symbol}
                                               labelStyle={{
                                                 color: resultSymbolSetting.passed.color,
                                                 background: getBackgroundSymbol(resultSymbolSetting, 'passed')
                                               }}
                                               classLabel="xl:text-[20px] text-[18px]">
                                </CheckboxInput>
                                <CheckboxInput name={`inspection_item_${item.id}`}
                                               id={`inspection_item_NG_${item.id}`}
                                               value="NG"
                                               disabled={!formRegister['has_inspected'] || !canInspect}
                                               onChange={() => handleCheckBoxChange(`inspection_item_${item.id}`, 'NG')}
                                               checked={formRegister[`inspection_item_${item.id}`] === 'NG'}
                                               label={resultSymbolSetting['failed'].symbol}
                                               labelStyle={{
                                                 color: resultSymbolSetting.failed.color,
                                                 background: getBackgroundSymbol(resultSymbolSetting, 'failed')
                                               }}
                                               classLabel="xl:text-[20px] text-[18px]">
                                </CheckboxInput>
                              </div>
                            )}
                            {item.inspection_item_type?.name === 'input' && (
                              <div className="flex">
                                <FormGroupInput className="items-center relative w-full">
                                  {getInspectionUnit(item.unit) !== "" ? (
                                    <>
                                      <TextInput name={`inspection_item_${item.id}`} type="text"
                                        autoFocus={index === firstInputIndex}
                                        onChange={(e) => handleInputChange(`inspection_item_${item.id}`, e.target.value)}
                                        value={formRegister[`inspection_item_${item.id}`] || ''}
                                        readOnly={!formRegister['has_inspected'] || !canInspect}
                                        disabled={!formRegister['has_inspected'] || !canInspect}
                                        hasError={hasErrorInput(errorMessagesRegister, `inspection_item_${item.id}`)}
                                        className="w-full tenken__text-gray-900 min-w-[200px] max-w-[280px] focus:ring-0 focus:border-[#D0D5DD] bg-white 2xl:pl-[14px] 2xl:pr-[104px] 2xl:py-[10px] xl:pl-[12px] xl:pr-[96px] xl:py-[8px] pl-[10px] pr-[40px] py-[6px] rounded-lg border border-[#D0D5DD]"
                                        {...(item.inspection_judgment?.input_value_type === INSPECTION_ITEM_JUDGMENT_INPUT_TYPE.TEXT)
                                          ? {maxLength: item.inspection_judgment?.max_string_length}
                                          : {}
                                        }
                                      />
                                      <CustomSpan
                                        title={item.unit}
                                        className="absolute right-3 2xl:text-[16px] tenken__text-gray-900 xl:text-[15px] text-[14px]"
                                      >
                                        {getInspectionUnit(item.unit)}
                                      </CustomSpan>
                                    </>
                                  ): (
                                    <>
                                      <TextInput name={`inspection_item_${item.id}`} type="text"
                                        autoFocus={index === firstInputIndex}
                                        onChange={(e) => handleInputChange(`inspection_item_${item.id}`, e.target.value)}
                                        value={formRegister[`inspection_item_${item.id}`] || ''}
                                        readOnly={!formRegister['has_inspected'] || !canInspect}
                                        disabled={!formRegister['has_inspected'] || !canInspect}
                                        hasError={hasErrorInput(errorMessagesRegister, `inspection_item_${item.id}`)}
                                        className="w-full tenken__text-gray-900 min-w-[200px] max-w-[280px] focus:ring-0 focus:border-[#D0D5DD] bg-white 2xl:px-[14px] 2xl:py-[10px] xl:px-[12px] xl:py-[8px] px-[10px] py-[6px] rounded-lg border border-[#D0D5DD]"
                                        {...(item.inspection_judgment?.input_value_type === INSPECTION_ITEM_JUDGMENT_INPUT_TYPE.TEXT)
                                          ? {maxLength: item.inspection_judgment?.max_string_length}
                                          : {}
                                        }
                                      />
                                    </>
                                  )}
                                </FormGroupInput>
                              </div>
                            )}
                          </Table.Cell>
                        </Table.Row>
                      ))
                    ) : (
                      null
                    )}
                  </Table.Body>
                </Table>
              </div>
            </div>

            <div className="relative rounded-lg border border-[#e0e0e0]">
              <Table className="no-drop-shadow-table" striped>
                <Table.Head className="whitespace-nowrap">
                  <Table.HeadCell
                    className="w-[43%]"
                  >
                    <span>点検者情報を入力・確認してください</span>
                  </Table.HeadCell>
                  <Table.HeadCell
                  >
                  </Table.HeadCell>
                </Table.Head>
                <Table.Body className="devide-y text-base whitespace-nowrap">
                  {resultField && Object.keys(resultField).length > 0 ? (
                    Object.entries(resultField).map(([key, value], index) => (
                      key !== 'registration_datetime' ? (
                        <Table.Row key={index}>
                          <Table.Cell>
                            <span className="tenken__text-gray-900">{value}</span>
                          </Table.Cell>
                          <Table.Cell>
                            <FormGroupInput className="!flex-col">
                              <FormGroupInput className="gap-[20px]">
                                {key == 'inspection_start_user_id' || key == 'operation_start_user_id' ? (
                                  <Select2
                                    options={managerUsers}
                                    className="xl:text-base text-gray-900 2xl:w-[320px] xl:w-[300px] lg:w-[280px] w-[260px] tenken__text-gray-900"
                                    classNamePrefix="react-select"
                                    maxLength={20}
                                    isDisabled={(key == 'operation_start_user_id' && !formRegister['has_inspected']) || !canInspect}
                                    isClearable={key == 'operation_start_user_id' ? true : false}
                                    onChange={(managerUsers) => handleSelectChange(managerUsers, key)}
                                    value={getSelectedValue(managerUsers, formRegister[key] || (key == 'operation_start_user_id' ? '' : auth.user.id))}
                                    placeholder=''
                                    name={key}
                                    hasError={hasErrorInput(errorMessagesRegister, key)}
                                  />
                                ) : (
                                  <DatetimePicker name={key}
                                                  id={`operation_start_datetime_${key}`}
                                                  onChange={handleInputChange}
                                                  value={formRegister[key]}
                                                  maxLength={16}
                                                  disabled={(key == 'operation_start_datetime' && !formRegister['has_inspected']) || !canInspect}
                                                  showClearButton={key == 'operation_start_datetime' ? true : false}
                                                  hasError={hasErrorInput(errorMessagesRegister, key)}
                                                  className="tenken__text-gray-900 2xl:w-[320px] xl:w-[300px] lg:w-[280px] w-[260px]">
                                  </DatetimePicker>
                                )}
                              </FormGroupInput>
                            </FormGroupInput>
                          </Table.Cell>
                        </Table.Row>
                      ) : (
                        null
                      )
                    ))
                  ) : (
                    null
                  )}
                </Table.Body>
              </Table>
            </div>
            <div
              className="flex flex-col 2xl:p-[24px] xl:p-[16px] p-[12px] bg-[#FFF] justify-center item-center rounded-lg w-full xl:gap-[20px] gap-[12px] border border-[#e0e0e0]">
              <div className="flex items-center">
                <InputLabel className="font-medium lg:text-[16px] text-[15px]" text="点検コメント"/>
                <TooltipComment isDisplay={canInspect}/>
              </div>
              <TextEditor
                onChange={handleInputChange}
                name="remark_text"
                commentFiles={tempInspection?.comment_files}
                setCommentFiles={setCommentFiles}
                remarkText={remarkText}
                canEdit={canInspect}
                setCommentImagesThumb={setCommentImagesThumb}
              />
            </div>
            <div className="flex items-center py-[10px] 2xl:gap-[80px] xl:gap-[60px] gap-[40px] justify-center"
                 id="scroll_bottom">
              <ButtonBack onClick={() => handleButtonBack()}/>
              <Button type="submit" theme={tenkenTheme.button}  color="light" className="rounded-lg border min-w-[280px]"  disabled={!canInspect}
                      id={BUTTON_REGISTER_TEMPORARY_INSPECTION} onClick={(e) => handleSubmitTemporary(e)}>
                <FiEdit2 className="text-white font-medium mr-[2px]" color="black" size={20}/>
                一時保存
              </Button>
              <Button type="submit" theme={tenkenTheme.button} color="primary" onClick={(e) => handleSubmit(e)}  disabled={!canInspect}
                      className="rounded-lg border min-w-[280px]" id={BUTTON_REGISTER_INSPECTION}>
                <LiaEditSolid className="text-white font-medium mr-[2px]" size={20}/>
                登録
              </Button>
            </div>
            <Modal show={showResume} className="z-[9999] hide-close">
              <Modal.Header className="px-[24px] py-[12px]">
                確認
              </Modal.Header>
              <Modal.Body className="px-[24px]">
                入力中のデータがあります。再開しますか？
              </Modal.Body>
              <Modal.Footer className="space-x-[32px] h-[80px] flex justify-center">
                <Button type="submit" theme={tenkenTheme.button} color="gray" onClick={() => handleButtonBack()}
                        className="rounded-lg border !min-w-[180px]">
                  戻る
                </Button>
                <Button type="submit" theme={tenkenTheme.button}  color="primary" className="rounded-lg border !min-w-[180px]"
                        onClick={() => setShowResume(false)}>
                  最初から
                </Button>
                <Button type="submit" theme={tenkenTheme.button}  color="yellow" className="rounded-lg border !min-w-[180px]"
                        onClick={(e) => handleSetTemporary(e)} id={BUTTON_SET_TEMPORARY_INSPECTION}>
                  再開する
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </BackendLayout>
  )
}